import React, { useEffect, useState, useRef } from "react";
import { useClickAway } from "react-use";
import { AnimatePresence, motion } from "framer-motion";
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import { LOGO } from "../../../assets";
import ARROW from "../../../assets/downarrow.png";
import { routes } from "./route";
import "./Header.css";

export default function HeaderMobile({ isOpen, setOpen, type }) {
  const ref = useRef(null);
  const [showTreatments, setShowTreatments] = useState(false);
  const treatmentsRef = useRef(null);

  const handleTreatmentsClick = (e) => {
    e.preventDefault();
    e.stopPropagation(); // Stop event from bubbling up
    setShowTreatments((prev) => !prev);
  };

  const handleClickOutside = (event) => {
    if (
      treatmentsRef.current &&
      !treatmentsRef.current.contains(event.target) &&
      !ref.current.contains(event.target)
    ) {
      setShowTreatments(false);
      setOpen(false); // Optional: Close the menu when clicking outside
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Close dropdown on navigation
  const closeMenuOnNavigate = () => {
    setShowTreatments(false);
    setOpen(false);
  };

  useClickAway(ref, () => setOpen(false));

  const treatmentsVariants = {
    hidden: { opacity: 0, y: -20 },
    visible: { opacity: 1, y: 0 },
  };

  const textHoverVariants = {
    hover: { scale: 1.1, color: "#B1F4F4" }, // Scale up and change text color
  };

  return (
    <div ref={ref} className="lg:hidden fixed w-full top-0 relative ">
      <div
        className={`py-2  ${
          !isOpen
            ? type === "primary"
              ? "bg-transparent"
              : "bg-[#35373A]"
            : "bg-[#35373A]"
        } w-full flex justify-between items-center px-10 h-[100px]`}
      >
        <Link
          to="/"
          onClick={(e) => {
            e.preventDefault(); // Prevent default navigation behavior
            setOpen(false); // First, close the menu
            setTimeout(() => {
              window.location.href = "/"; // Then, navigate to the page after delay
            }, 280); // Adjust delay (300ms) as needed
          }}
        >
          <img src={LOGO.LOGO} alt="logo" className="h-[50px]" />
        </Link>
        <div
          className="bg-ed flex relative w-8 h-8 flex-col justify-between items-end lg:hidden z-20 cursor-pointer"
          onClick={() => {
            setOpen(!isOpen);
            setShowTreatments(false);
          }}
        >
          <span
            className={`h-1 w-full bg-white rounded-lg transform transition duration-300 ease-in-out ${
              isOpen ? "rotate-45 translate-y-3.5" : ""
            }`}
          />
          <span
            className={`h-1 w-[25px] rounded-lg transition-all duration-300 ease-in-out ${
              isOpen ? "w-[0px] bg-secondary" : "w-full bg-white"
            }`}
          />
          <span
            className={`h-1 w-full bg-white rounded-lg transform transition duration-300 ease-in-out ${
              isOpen ? "-rotate-45 -translate-y-3.5" : ""
            }`}
          />
        </div>
      </div>
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.2 }}
            className="fixed left-0 shadow-4xl right-0 p-5 pt-0 bg-secondary border-b border-b-white/20"
          >
            <ul className="grid gap-2">
              {routes.map((route, idx) => {
                return (
                  <motion.li
                    initial={{ scale: 0, opacity: 0 }}
                    animate={{ scale: 1, opacity: 1 }}
                    transition={{
                      type: "spring",
                      stiffness: 260,
                      damping: 20,
                      delay: 0.1 + idx / 10,
                    }}
                    key={route.title}
                    className="w-full p-[0.08rem] rounded-xl bg-gradient-to-tr from-neutral-800 via-neutral-950 to-neutral-700 font-poppins"
                  >
                    {route.href && route.href.startsWith("#") ? (
                      <HashLink
                        smooth
                        // onClick={() => {
                        //   setOpen(false);
                        //   setTimeout(() => {
                        //     window.location.hash = route.hash;
                        //   }, 300);
                        // }}
                        onClick={closeMenuOnNavigate}
                        to={route.href}
                        className="flex items-center justify-center w-full p-5 rounded-xl bg-secondary text-white cursor-pointer "
                      >
                        <span className="flex items-center justify-center gap-1 text-base font-poppins">
                          {route.title}
                        </span>
                      </HashLink>
                    ) : (
                      <Link
                        // onClick={
                        //   route.title === "TREATMENTS"
                        //     ? handleTreatmentsClick
                        //     : undefined
                        // }
                        className="flex items-center justify-center w-auto p-5 rounded-xl bg-secondary text-white cursor-pointer hover:text-primary"
                        to={route.href}
                        onClick={closeMenuOnNavigate}
                      >
                        <span
                          className="flex items-center justify-center"
                          onClick={
                            route.title === "Treatments"
                              ? handleTreatmentsClick
                              : undefined
                          }
                        >
                          {route.title}
                          {route.title === "Treatments" && (
                            <img
                              src={ARROW}
                              alt="Treatments"
                              className="w-auto"
                            />
                          )}
                        </span>
                        {route.title === "Treatments" && showTreatments && (
                          <motion.div
                            initial="hidden"
                            animate="visible"
                            variants={treatmentsVariants}
                            transition={{ duration: 0.5 }}
                            ref={treatmentsRef}
                            className="relative z-99"
                          >
                            <div className="absolute top-[8px] -left-[52px] transform translate-x-1/2">
                              <div className="w-0 h-0 border-l-[20px] border-l-transparent border-r-[20px] border-r-transparent border-b-[20px] border-b-secondary"></div>
                            </div>
                            {/* <div className="absolute top-[8px] -left-[52px] transform translate-x-1/2">
                              <div className="w-0 h-0 border-l-[20px] border-l-transparent border-r-[20px] border-r-transparent border-b-[20px] border-b-white"></div>
                            </div> */}
                            <div className="bg-secondary text-white rounded-lg shadow-lg absolute -top-[8px] -right-[40px] mt-8 w-[180px] py-3 z-999999">
                              {/* <div className="bg-secondary text-grow rounded-lg shadow-lg absolute -top-[8px] -right-[40px] mt-8 w-[180px] py-3 z-999999"> */}
                              {/* <div className="bg-white text-grow rounded-lg shadow-lg absolute -top-[8px] -right-[40px] mt-8 w-[180px] py-3 z-999999"> */}
                              <div className="pl-[8%] font-poppins ">
                                <HashLink
                                  smooth
                                  to="/treatment/pedodontists"
                                  // onClick={() => {
                                  //   setOpen(false);
                                  //   setTimeout(() => {
                                  //     window.location.hash = "Pedodontists";
                                  //   }, 300);
                                  // }}
                                  onClick={() => {
                                    setOpen(false); // Close the menu
                                    setTimeout(() => {
                                      const element =
                                        document.getElementById("Pedodontists");
                                      if (element) {
                                        const offsetTop =
                                          element.offsetTop - 30;
                                        window.scrollTo({
                                          top: offsetTop,
                                          behavior: "smooth",
                                        });
                                        // Update the URL hash after scrolling
                                        window.history.pushState(
                                          null,
                                          null,
                                          "#Pedodontists"
                                        );
                                      }
                                    }, 300); // Adjust delay as needed
                                  }}
                                >
                                  <motion.div
                                    whileHover="hover"
                                    variants={textHoverVariants}
                                    className=" py-[9%] text-base hover:font-normal font-light tracking-tigh"
                                  >
                                    Pedodontists
                                  </motion.div>
                                </HashLink>
                                {/* <hr className="border-t-1 border-[#E2E2E2]" /> */}
                                <div className="bg-rd flex items-center justify-center w-full pr-[9%]">
                                  <hr className="text-[#DFDFDF] w-full h-[4px]" />
                                </div>
                                <HashLink
                                  to="/treatment/orthodontists"
                                  smooth
                                  // onClick={() => {
                                  //   setOpen(false);
                                  //   setTimeout(() => {
                                  //     window.location.hash = "Orthodontists";
                                  //   }, 300);
                                  // }}
                                  onClick={() => {
                                    setOpen(false); // Close the menu
                                    setTimeout(() => {
                                      const element =
                                        document.getElementById(
                                          "Orthodontists"
                                        );
                                      if (element) {
                                        const offsetTop =
                                          element.offsetTop - 30;
                                        window.scrollTo({
                                          top: offsetTop,
                                          behavior: "smooth",
                                        });
                                        // Update the URL hash after scrolling
                                        window.history.pushState(
                                          null,
                                          null,
                                          "#Orthodontists"
                                        );
                                      }
                                    }, 300); // Adjust delay as needed
                                  }}
                                >
                                  <motion.div
                                    whileHover="hover"
                                    variants={textHoverVariants}
                                    className="py-[9%] text-base hover:font-normal font-light tracking-tigh"
                                  >
                                    Orthodontists
                                  </motion.div>
                                </HashLink>
                                {/* <hr className="border-t-1 border-[#E2E2E2]" /> */}
                                <div className="bg-rd flex items-center justify-center w-full pr-[9%]">
                                  <hr className="text-[#DFDFDF] w-full h-[4px]" />
                                </div>
                                <HashLink
                                  to="/treatment/periodontists"
                                  smooth
                                  // onClick={() => {
                                  //   setOpen(false);
                                  //   setTimeout(() => {
                                  //     window.location.hash = "Periodontists";
                                  //   }, 300);
                                  // }}
                                  onClick={() => {
                                    setOpen(false); // Close the menu
                                    setTimeout(() => {
                                      const element =
                                        document.getElementById(
                                          "Periodontists"
                                        );
                                      if (element) {
                                        const offsetTop =
                                          element.offsetTop - 30;
                                        window.scrollTo({
                                          top: offsetTop,
                                          behavior: "smooth",
                                        });
                                        // Update the URL hash after scrolling
                                        window.history.pushState(
                                          null,
                                          null,
                                          "#Periodontists"
                                        );
                                      }
                                    }, 300); // Adjust delay as needed
                                  }}
                                >
                                  <motion.div
                                    whileHover="hover"
                                    variants={textHoverVariants}
                                    className="py-[9%] text-base hover:font-normal font-light tracking-tigh"
                                  >
                                    Periodontists
                                  </motion.div>
                                </HashLink>
                                {/* <hr className="border-t-1 border-[#E2E2E2]" /> */}
                                <div className="bg-rd flex items-center justify-center w-full pr-[9%]">
                                  <hr className="text-[#DFDFDF] w-full h-[4px]" />
                                </div>
                                <HashLink
                                  to="/treatment/endodontists"
                                  smooth
                                  // onClick={() => {
                                  //   setOpen(false);
                                  //   setTimeout(() => {
                                  //     window.location.hash = "Endodontists";
                                  //   }, 300);
                                  // }}
                                  onClick={() => {
                                    setOpen(false); // Close the menu
                                    setTimeout(() => {
                                      const element =
                                        document.getElementById("Endodontists");
                                      if (element) {
                                        const offsetTop =
                                          element.offsetTop - 30;
                                        window.scrollTo({
                                          top: offsetTop,
                                          behavior: "smooth",
                                        });
                                        // Update the URL hash after scrolling
                                        window.history.pushState(
                                          null,
                                          null,
                                          "#Endodontists"
                                        );
                                      }
                                    }, 300); // Adjust delay as needed
                                  }}
                                >
                                  <motion.div
                                    whileHover="hover"
                                    variants={textHoverVariants}
                                    className="py-[9%] text-base hover:font-normal font-light tracking-tigh"
                                  >
                                    Endodontists
                                  </motion.div>
                                </HashLink>
                              </div>
                            </div>
                          </motion.div>
                        )}
                      </Link>
                    )}
                  </motion.li>
                );
              })}
              <motion.li
                initial={{ scale: 0, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                transition={{
                  type: "spring",
                  stiffness: 260,
                  damping: 20,
                  delay: 0.1 + 6 / 10,
                }}
                className="w-full p-[0.08rem] rounded-xl bg-gradient-to-tr from-neutral-800 via-neutral-950 to-neutral-700"
              >
                {/* <button className="bg-primary glow-on-hover button w-full px-8 py-2 text-secondry font-bold rounded-full">CONTACT</button> */}
              </motion.li>
            </ul>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
